/**
 * Locale-aware Navigation Helpers
 *
 * Drop-in replacements for next/link and next/navigation that automatically
 * handle locale prefixing based on the routing configuration.
 *
 * Usage:
 *   import { Link, useRouter, usePathname, redirect } from '@/i18n/navigation';
 */

import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
